// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { ClientsManagementGet } from '../../../../types/server/modules/clientsManagement/get';

export type * from '../../../../types/server/modules/clientsManagement/get';

export const createGet = ( requests: Requests ): ClientsManagementGet => ({
  generate_app_login_url: ( headers ) => {
      return requests.get( `/clients-management/generate-app-login-url`, undefined, headers );
    }
});
